module.exports = __webpack_public_path__ + "media/images/home/free_storage_badge-18324378d982b70b2524961bfc4c4815.svg";